import { UserRole, AccessLevel } from '@data/models/authorization.model';
import { Role } from '@data/models/role.model';

export class ScopeHelper {
    scopesToString(scopes: Array<{ key; read; edit; admin? }>, flat: boolean = false): string[] {
        return scopes.flatMap(({ key, read, edit, admin }) => {
            return flat ? `${key}: ${read ? 'read' : ''}${read && edit ? ', ' : '' }${edit ? 'edit' : ''}${(read || edit) && admin ? ', ' : '' }${admin ? 'admin' : ''}`
                : [
                    read && `${key}:read`,
                    edit && `${key}:edit`,
                    admin && `${key}:admin`,
                ];
        }).filter(Boolean);
    }

    scopesFromString(scopes: string[]): Array<{ key; read; edit; admin }> {
        const formattedScopes: Array<{ key; read; edit; admin }> = [];
        for (const scopeString of scopes) {
            const partialScope = scopeString.split(':');
            const scope = formattedScopes.find(val => {
                return val.key === partialScope[0];
            });
            if (!scope) {
                const i = formattedScopes.push({ key: partialScope[0], read: false, edit: false, admin: false });
                formattedScopes[i - 1][partialScope[1]] = true;
            } else {
                scope[partialScope[1]] = true;
            }
        }
        return formattedScopes;
    }

    getMissingRoles(userRoles: UserRole[], globalRoles: Role[], scopes: Array<{ key; read; edit; admin }>) {
        const roles = userRoles.flatMap(userRole => {
            return userRole.roles;
        });
        const userAcl = globalRoles.filter(role => {
            return roles.includes(role.id);
        }).flatMap((role) => role.acl);

        const missingAcl = scopes.map(({ key, read, edit }) => {
            const level = userAcl.find(({ entity }) => entity === key)?.level;
            switch (level && AccessLevel[level]) {
                case AccessLevel.READ:
                    return { key, read: false, edit };
                case AccessLevel.EDIT:
                    return { key, read: false, edit: false };
                case AccessLevel.ADMIN:
                    return { key, read: false, edit: false };
                default:
                    return { key, read, edit };
            }
        }).filter(({ read, edit }) => read || edit);
        return this.scopesToString(missingAcl, true);
    }
}
